import { api } from '$app/api';

export function listGarageUpdates(garageId, { limit, offset }) {
  return api.get(`/garages/${garageId}/updates`, { params: { limit, offset } }).then((res) => res.data);
}
